import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  InformationServiceTransaction,
  ServiceTransactionInitState, VerifyCodeInterface
} from '@/store/service-transaction/service-transaction.types';
import {MemberInitState} from '@/store/member/member.types';
import {Toast} from '@/store/toast/toast.types';
import moment from 'moment';
import {TimeUsed} from '@/services/time.service';
import {Helper} from '../../../util/helper';

interface ViewInformation {
  topic: string;
  date: string;
  remark: string;
  startDate: string;
  timeUsed: string;
  ownerTimeLeft: string;
  detail: string;
  timeTitle: string;
}

@Component({
  components: {}
})
export default class PaymentInformationComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('member') memberInitState!: MemberInitState;
  @Action('_information', {namespace: 'serviceTransaction'}) information!: () => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;

  public info = {} as InformationServiceTransaction;
  public lib: Helper = new Helper();

  public view: ViewInformation = {
    detail: '',
    ownerTimeLeft: '0',
    timeUsed: '',
    topic: '',
    remark: '',
    date: '',
    startDate: '-',
    timeTitle: ''
  };

  async mounted() {
    try {
      this.Loading(true);
      await this.information();
      this.info = this.serviceTransactionInitState.information;
      console.log( this.info)
      this.view.topic = `${this.info.subService.service.serviceName} ${this.info.subService.name}`;
      this.view.date = `${this.lib.formatDateTimeThai(this.info.serviceDate)}`;
      this.view.remark = `${this.info.remark}`;
      this.view.startDate = `${moment(this.info.serviceStartDate).format('HH:mm')}`;
      this.view.ownerTimeLeft = this.info.pointLeft;
      if (this.info.serviceStartDate) {
        this.view.timeUsed = TimeUsed({
          timeStart: this.info.serviceStartDate,
          timeEnd: new Date()
        });
      } else {
        this.view.timeUsed = `เมื่อสักครู่`
      }
      this.info.isOwner
        ? this.view.timeTitle = 'เวลาคงเหลือ (นาที)'
        : this.view.timeTitle = 'เวลาคงเหลือ ของผู้รับบริการ (นาที)';
      this.Loading(false);
    } catch (e) {
      this.Toast({
        type: 'warning',
        message: 'ไม่พบข้อมูล',
        heading: 'ผิดพลาด'
      });
      this.Loading(false);
      this.$router.push('/').then();
    }
  }

  stopServiceClick() {
    this.$router.push('/payment-rating').then();
  }

  checkTime() {
    this.Loading(true);
    location.reload();
  }
}


